import { render } from "./TradePreviewModal.vue?vue&type=template&id=f80dc172&scoped=true&ts=true"
import script from "./TradePreviewModal.vue?vue&type=script&lang=ts"
export * from "./TradePreviewModal.vue?vue&type=script&lang=ts"

import "./TradePreviewModal.vue?vue&type=style&index=0&id=f80dc172&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f80dc172"]])

export default __exports__